import { BaseFilter } from "@/services/filters/classes/base.filter";
import { ConstructorType } from "@/services/filters/classes/types";
import { IFilter } from "@/types";

export enum COMPARE_OPERATORS {
    GT = 'gt',
    GTE = 'gte',
    LT = 'lt',
    LTE = 'lte',
    EQ = 'eq',
    BETWEEN = 'between',
}

export class CompareFilter extends BaseFilter {
    operations?: COMPARE_OPERATORS[];

    constructor(config: ConstructorType<CompareFilter, 'compare'>) {
        super(config);
        this.compare = true;
        this.operations = config.operations ?? [
            COMPARE_OPERATORS.GT,
            COMPARE_OPERATORS.GTE,
            COMPARE_OPERATORS.LT,
            COMPARE_OPERATORS.LTE,
            COMPARE_OPERATORS.BETWEEN,
        ];
        this.operator = COMPARE_OPERATORS.GT;
    }

    clear(): void {
        this.select = [];
        this.operator = COMPARE_OPERATORS.GT;
    }

    getValueForSubmit(filter: IFilter = this): Record<string, any> {
        if (!filter.select?.length) return {};
        return { [filter.id]: filter.select, [`${filter.id}_operator`]: filter.operator };
    }

    parseQueryAndGetChanges(query: any, currentQueryKey: any): any {
        const queryValue = query[currentQueryKey];

        if (Array.isArray(queryValue) && queryValue.length === 2) {
            this.select = queryValue.map(Number);
            this.operator = COMPARE_OPERATORS.BETWEEN;
        } else {
            this.select = [Number(queryValue)];
            this.operator = query[`${currentQueryKey}_operator`];
        }

        return { [this.id]: this.select, [`${this.id}_operator`]: this.operator };
    }
}
